import {
	extractResourceStatePromise,
	mergeOptionsWithDefaults,
} from '@jira/router-resources__assets-admin-settings/src/extractResourceStatePromise.tsx';
import { getResourceStore } from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export type AssetsReportingConfig = {
	status: 'success' | 'error';
	data: AssetsReportingConfigResponse;
};

export type AssetsReportingConfigResponse = {
	isAssetsReportingEnabled: boolean;
};

export const getAssetsReportingConfig = async (): Promise<AssetsReportingConfig> => {
	try {
		const { storeState } = getResourceStore();
		const state = storeState.getState();
		const workspaceId = await extractResourceStatePromise(state.data);
		if (!workspaceId || typeof workspaceId !== 'string') {
			return { status: 'error', data: { isAssetsReportingEnabled: false } };
		}
		const url = __SERVER__
			? '/api/v1/config'
			: `/gateway/api/jsm/reporting/assets/workspace/${workspaceId}/config`;

		const mergedOptions = mergeOptionsWithDefaults(url, {
			headers: {
				'x-ssr-service-name': 'jsm-reporting',
				'atl-workspaceid': workspaceId,
				'atl-workspacetype': 'assets',
			},
		});
		const response = await performGetRequest<AssetsReportingConfigResponse>(url, mergedOptions);
		if (!response || typeof response.isAssetsReportingEnabled !== 'boolean') {
			return { status: 'error', data: { isAssetsReportingEnabled: false } };
		}
		return { status: 'success', data: response };
	} catch {
		return { status: 'error', data: { isAssetsReportingEnabled: false } };
	}
};
